/* Dashboard telemetry only: no identity creation, cart writes, experiment assignment or consent UI. */
(function () {
  'use strict';
  if (window.MaleziaTelemetry) return;
  var queue = [], timer = null, sentImpressions = {}, observed = new Map(), pending = new Set();
  var widgets = ['smart_cart', 'cart_cross_sell', 'pdp_complete_the_look', 'pdp_customers_also_bought', 'pdp_you_may_also_like', 'home_best_sellers'];
  function router() { return window.MaleziaSmartCartRollout; }
  function source() {
    var s = window.Shopify || {}, r = router(), c = r && r.config;
    var q = new URLSearchParams(location.search);
    if (s.designMode === true || s.designMode === 'true' || (s.theme && s.theme.role === 'unpublished') || q.has('preview_theme_id') || q.has('_fd') || q.has('pb')) return 'preview';
    if ((r && r.qa) || q.has('malezia_smart_cart_qa') || q.has('malezia_byob_qa') || q.has('malezia_qa') || q.has('malezia_test')) return 'test';
    // Router resolves private QA asynchronously; never label its boot window as public live.
    if (s.theme && s.theme.role === 'main' && r && r.decision && c && c.source === 'live' && String(s.theme.id) === c.themeId) return 'live';
    return 'unknown';
  }
  function eligible() {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      return !!p && typeof p.currentVisitorConsent === 'function' && typeof p.analyticsProcessingAllowed === 'function' && p.currentVisitorConsent().analytics !== 'no' && p.analyticsProcessingAllowed() === true;
    } catch (_) { return false; }
  }
  function sid() { var r = router(); return r && /^[A-Za-z0-9_-]{8,64}$/.test(r.sessionId || '') ? r.sessionId : null; }
  function allowed() { return eligible() && source() === 'live' && !!sid(); }
  function discard() {
    queue.length = 0;
    if (timer !== null) clearTimeout(timer);
    timer = null;
    pending.forEach(function (c) { c.abort(); }); pending.clear();
  }
  function flush() {
    if (!allowed()) { discard(); return false; }
    if (timer !== null) clearTimeout(timer);
    timer = null;
    var batch = queue.splice(0, 50).filter(function (e) { return e.session_id === sid() && e.source === source(); });
    if (!batch.length) return false;
    try {
      var controller = new AbortController(); pending.add(controller);
      // At-most-once attempts: never replay ambiguous network failures or accumulate offline data.
      Promise.resolve(window.fetch('/apps/malezia-merch/t', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ events: batch }), keepalive: true, signal: controller.signal
      })).catch(function () {}).then(function () { pending.delete(controller); });
      return true;
    } catch (_) { return false; }
  }
  function put(event, widget, extra) {
    if (!allowed()) { discard(); return false; }
    if (widgets.indexOf(widget) < 0 || ['impression', 'click', 'atc', 'drawer_open', 'checkout'].indexOf(event) < 0) return false;
    if (event === 'impression' && sentImpressions[widget]) return false;
    extra = extra || {};
    var row = { ts: Date.now(), source: source(), session_id: sid(), event: event, widget: widget, page: location.pathname.slice(0, 160) };
    // Only schema-approved scalars; never URLs, customer information, arbitrary metadata or query strings.
    ['product', 'variant_id'].forEach(function (k) { if (/^[0-9]{1,24}$/.test(String(extra[k]))) row[k] = String(extra[k]); });
    ['qty', 'value'].forEach(function (k) { var v = extra[k]; if (typeof v === 'number' && isFinite(v) && v >= (k === 'qty' ? 1 : 0) && v <= (k === 'qty' ? 999 : 100000000)) row[k] = Math.round(v); });
    ['experiment', 'variant'].forEach(function (k) { if (typeof extra[k] === 'string' && /^[a-z0-9][a-z0-9_-]{0,47}$/.test(extra[k])) row[k] = extra[k]; });
    if (event === 'impression') sentImpressions[widget] = true;
    queue.push(row);
    if (queue.length >= 50) flush();
    else if (timer === null) timer = setTimeout(flush, 300);
    return true;
  }
  function visible(node) {
    if (!node || !node.isConnected || document.visibilityState === 'hidden' || node.closest('[hidden], [aria-hidden="true"]')) return false;
    var style = window.getComputedStyle(node), rect = node.getBoundingClientRect();
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0 || rect.width <= 0 || rect.height <= 0) return false;
    return rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
  }
  function check(node) {
    var data = observed.get(node);
    if (data && io && data.intersecting && visible(node)) put('impression', data.widget, data.extra);
  }
  var io = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) { var data = observed.get(entry.target); if (data) data.intersecting = entry.isIntersecting && entry.intersectionRatio > 0; check(entry.target); });
  }, { threshold: [0, 0.01] }) : null;
  function observe(node, widget, extra) {
    if (!node) return;
    widget = widget || node.getAttribute('data-mpg-widget') || node.getAttribute('data-mm-widget');
    if (widgets.indexOf(widget) < 0) return;
    if (!extra) {
      var exp = (node.getAttribute('data-mm-exp') || '').split(':');
      extra = exp.length === 2 ? { experiment: exp[0], variant: exp[1] } : {};
    }
    var prior = observed.get(node);
    observed.set(node, { widget: widget, extra: extra, intersecting: prior ? prior.intersecting : false });
    if (!prior && io) io.observe(node);
    check(node);
  }
  function scan() {
    // Only the native drawer and its recommendation mount. Existing native click/ATC hooks own those events.
    document.querySelectorAll('[data-malezia-cart]').forEach(function (drawer) {
      observe(drawer, 'smart_cart');
      drawer.querySelectorAll('[data-mm-xsell][data-mm-widget]').forEach(function (node) { observe(node); });
    });
    observed.forEach(function (_, node) {
      if (!node.isConnected) { if (io) io.unobserve(node); observed.delete(node); }
      else check(node);
    });
  }
  function track(event, widget, extra) {
    try {
      // Native calls this just BEFORE unhiding the drawer. Wait for real visibility.
      if (event === 'impression' && widget === 'smart_cart') { var drawer = document.querySelector('[data-malezia-cart]'); if (drawer) observe(drawer, widget, extra); return false; }
      return put(event, widget, extra);
    } catch (_) { return false; }
  }
  window.MaleziaTelemetry = { track: track, flush: flush, observe: observe, assign: function () { return null; } };
  Object.defineProperties(window.MaleziaTelemetry, { sid: { get: function () { return eligible() ? sid() : null; } }, source: { get: source } });
  document.addEventListener('visitorConsentCollected', function () { if (!allowed()) discard(); else scan(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); else scan(); });
  window.addEventListener('pagehide', flush);
  window.addEventListener('scroll', scan, { passive: true });
  window.addEventListener('resize', scan, { passive: true });
  // A widget can intersect while the router is still resolving its existing cart/QA
  // decision. Its geometry may never change again; recheck readiness independently
  // of DOM mutations/scroll without replaying any pre-ready interaction events.
  var readinessChecks = 0;
  function checkReadiness() {
    var r = router(), kind = source();
    if (kind === 'preview' || kind === 'test') return;
    if (r && r.decision) { scan(); return; }
    if (++readinessChecks < 120) setTimeout(checkReadiness, 500);
  }
  function start() {
    scan();
    checkReadiness();
    if (typeof MutationObserver === 'function' && document.body) new MutationObserver(scan).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-hidden', 'class', 'data-mm-widget'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
